import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as vendingService from "data/server_apis/vendingServices";
const initialState = {
  getDisplayConfigurationsLoading: false,
  getDisplayConfigurationsError: false,
  getDisplayConfigurationsSuccess: false,
  getDisplayConfigurationsMessage: null,

  updateDisplayConfigurationsLoading: false,
  updateDisplayConfigurationsError: false,
  updateDisplayConfigurationsSuccess: false,
  updateDisplayConfigurationsMessage: null,
  displayConfigs: {},
};

export const getDisplayConfigurationsThunk = createAsyncThunk(
  "vendingConfig/getDisplayConfig",
  async (id, { rejectWithValue }) => {
    try {
      return (await vendingService.getDisplayConfigurations(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const updateDisplayConfigurationsThunk = createAsyncThunk(
  "vendingConfig/updateDisplayConfig",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await vendingService.updateDisplayConfigurations(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const machineConfig = createSlice({
  name: "machineConfig",
  initialState,
  reducers: {
    clearConfig(state, action) {
      state.getDisplayConfigurationsLoading = false;
      state.getDisplayConfigurationsError = false;
      state.getDisplayConfigurationsSuccess = false;
      state.getDisplayConfigurationsMessage = null;

      state.updateDisplayConfigurationsLoading = false;
      state.updateDisplayConfigurationsError = false;
      state.updateDisplayConfigurationsSuccess = false;
      state.updateDisplayConfigurationsMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDisplayConfigurationsThunk.pending, (state, action) => {
        state.getDisplayConfigurationsLoading = true;
        state.getDisplayConfigurationsError = false;
        state.getDisplayConfigurationsSuccess = false;
        state.getDisplayConfigurationsMessage = null;
      })
      .addCase(getDisplayConfigurationsThunk.rejected, (state, action) => {
        state.getDisplayConfigurationsLoading = false;
        state.getDisplayConfigurationsError = true;
        state.getDisplayConfigurationsSuccess = false;
        state.getDisplayConfigurationsMessage = action.payload?.message;
      })
      .addCase(getDisplayConfigurationsThunk.fulfilled, (state, action) => {
        state.getDisplayConfigurationsLoading = false;
        state.getDisplayConfigurationsError = false;
        state.getDisplayConfigurationsSuccess = true;
        state.getDisplayConfigurationsMessage = null;
        state.displayConfigs[action.meta.arg] = action.payload;
      });

    builder
      .addCase(updateDisplayConfigurationsThunk.pending, (state, action) => {
        state.updateDisplayConfigurationsLoading = true;
        state.updateDisplayConfigurationsError = false;
        state.updateDisplayConfigurationsSuccess = false;
        state.updateDisplayConfigurationsMessage = null;
      })
      .addCase(updateDisplayConfigurationsThunk.rejected, (state, action) => {
        state.updateDisplayConfigurationsLoading = false;
        state.updateDisplayConfigurationsError = true;
        state.updateDisplayConfigurationsSuccess = false;
        state.updateDisplayConfigurationsMessage = action.payload?.message;
      })
      .addCase(updateDisplayConfigurationsThunk.fulfilled, (state, action) => {
        state.updateDisplayConfigurationsLoading = false;
        state.updateDisplayConfigurationsError = false;
        state.updateDisplayConfigurationsSuccess = true;
        state.updateDisplayConfigurationsMessage = null;
        state.displayConfigs[action.meta.arg.data.machine] = action.payload;
      });
  },
});

export const { clearConfig } = machineConfig.actions;

export default machineConfig.reducer;
